export default __webpack_public_path__ + "guide--raster-rasters-are-pixels-480-1717102f4d2ae423e2b4793046271895.webp";